import { createElement, useEffect, useRef, useState, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { Animated } from '@max/mbc-animated';
import AnimateView from '@max/mbc-animate-view';
import Image from '@hfe/max-image';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import './index.scss';
// 与 scss 中 line-height: 36rpx 对应的像素值
const ITEM_HEIGHT = rpx2px(36);
// 每条展示停留时长（ms）
const DISPLAY_DURATION = 1500;
// 向上滑出动画时长（ms）
const SLIDE_DURATION = 400;
const NoticeSlider = (props) => {
    const { items, containerStyle, contentStyle } = props;
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentIndexRef = useRef(0);
    const translateY = useRef(new Animated.Value(0));
    const timerRef = useRef(null);
    const totalRef = useRef(items.length);
    // 同步 totalRef，供 effect 闭包内读取最新 length
    totalRef.current = items.length;
    useEffect(() => {
        if (items.length <= 1)
            return;
        function scheduleNext() {
            timerRef.current = setTimeout(() => {
                // 向上滑出
                Animated.timing(translateY.current, {
                    toValue: -ITEM_HEIGHT,
                    duration: SLIDE_DURATION,
                    useNativeDriver: true,
                    easing: Animated.Easing.ease
                }).start(() => {
                    const nextIndex = (currentIndexRef.current + 1) % totalRef.current;
                    currentIndexRef.current = nextIndex;
                    // 修复闪烁：先归零位移，再更新 index，确保新文本渲染时位移已为 0
                    translateY.current.setValue(0);
                    setCurrentIndex(nextIndex);
                    scheduleNext();
                });
            }, DISPLAY_DURATION);
        }
        scheduleNext();
        return () => {
            clearTimeout(timerRef.current);
            translateY.current.setValue(0);
        };
    }, [items.length]);
    if (items.length === 0) {
        return null;
    }
    const currentText = items[currentIndex];
    const nextText = items[(currentIndex + 1) % items.length];
    return <View className="notice-slider-container" style={containerStyle}>
      <Image source={{
        uri: 'https://img.meituan.net/makerjiulv/49c15f9383878a02d06ea61c61ce1c571032.png'
    }} style={{
        width: '22rpx',
        height: '22rpx',
        marginRight: '5rpx'
    }}/>
      <View className="notice-slider-text-wrapper" style={contentStyle}>
        <AnimateView viewId="notice-slider-scroller" style={{
        flexDirection: 'column',
        transform: [{
                translateY: translateY.current
            }]
    }}>
          <Text className="notice-slider-text" numberOfLines={1}>
            {currentText}
          </Text>
          {items.length > 1 && <Text className="notice-slider-text" numberOfLines={1}>
              {nextText}
            </Text>}
        </AnimateView>
      </View>
    </View>;
};
export default memo(NoticeSlider);
